<template>
  <div class="eq-empty-state">
    <i :class="icon" class="eq-empty-state__icon"></i>
    <h3 class="eq-empty-state__title">{{ title }}</h3>
    <p v-if="description" class="eq-empty-state__desc">{{ description }}</p>
    <div v-if="$slots.default" class="eq-empty-state__action">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'EmptyState',
  props: {
    title: { type: String, default: '暂无数据' },
    description: { type: String, default: '' },
    icon: { type: String, default: 'el-icon-folder-opened' }
  }
}
</script>

<style lang="scss" scoped>
.eq-empty-state {
  display: flex; flex-direction: column; align-items: center; justify-content: center;
  padding: 80px 40px; text-align: center;
}
.eq-empty-state__icon { font-size: 56px; color: #d1d5db; margin-bottom: 20px; }
.eq-empty-state__title { margin: 0 0 8px; font-size: 16px; font-weight: 600; color: #64748b; }
.eq-empty-state__desc { margin: 0 0 20px; font-size: 13px; color: #94a3b8; line-height: 1.6; }
.eq-empty-state__action { margin-top: 8px; }
</style>
